import { render, staticRenderFns } from "./UserSidebarContent.vue?vue&type=template&id=0516de59&scoped=true&"
import script from "./UserSidebarContent.vue?vue&type=script&lang=js&"
export * from "./UserSidebarContent.vue?vue&type=script&lang=js&"
import style0 from "./UserSidebarContent.vue?vue&type=style&index=0&id=0516de59&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0516de59",
  null
  
)

export default component.exports